export default {
  getFolders() {
    return axios.get('/file/folder_list_all')
  }
}